module.exports = __webpack_public_path__ + "static/img/top5-qxqg.c2f2aae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top5-qxqg.png
// module id = D798
// module chunks = 9